import { app } from '../../bootstrap/core';
import { publicState } from './public.state';
import { publicComponent } from './public.component';
import { CDN_PATH, CDN_MPATH } from './public.constants';

const config = ($sceDelegateProvider, CDN_PATH, CDN_MPATH) => {
  'ngInject';
  // Allow loading from our assets domain.
  $sceDelegateProvider.resourceUrlWhitelist([
    `${CDN_PATH}/**`,
    `${CDN_MPATH}/**`,
    '**',
  ]);
};

angular
  .module(app.name)
  .constant('CDN_PATH', CDN_PATH)
  .constant('CDN_MPATH', CDN_MPATH)
  .config(config)
  .config(publicState)
  .component(publicComponent.name, publicComponent);
